module.exports = __webpack_public_path__ + "static/media/IAQAnalytics1.284f15d9.png";